import React, {useContext, useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {Button, Col, Container, InputGroup, Row, Spinner} from "react-bootstrap";
import * as backendUtils from "../helper/BackendUtils";
import {getErrorMessage} from "../helper/BackendUtils";
import {toast} from "react-toastify";
import AppContext from "../contexts/app-context";
import JoinEvent from "./JoinEvent";
import './NewParticipant.css';

const stravaRegex = new RegExp(/^\d+$/)

const NewParticipant = () => {
    const context = useContext(AppContext);
    const [error, setError] = useState("");
    const [userId, setUserId] = useState("");
    const [participant, setParticipant] = useState(null);
    const [showSpinner, setShowSpinner] = useState(true);
    const [sex, setSex] = useState("T");
    const [stravaId, setStravaId] = useState("");
    const [valid, setValid] = useState(false);
    const [activeEvents, setActiveEvents] = useState([]);
    const [rulesAccepted, setRulesAccepted] = useState(false);

    useEffect(() => {
        setRulesAccepted(participant !== null)
    }, [activeEvents, participant])

    useEffect(() => {
        const validateForm = () => {
            const required = rulesAccepted;
            const optional = (isSexValid(sex) || sex === "T") && (stravaId === "" || isStravaIdValid(stravaId))
            setValid(optional && required)
        }
        validateForm()
    }, [stravaId, sex, rulesAccepted])

    useEffect(() => {
        if (error) {
            console.log(error)
            toast(error)
        }
    }, [error])

    const getParticipant = () => {
        if (context.backendUri && userId) {
            backendUtils.getRequest(`${context.backendUri}/participant/${userId}`, {}, response => {
                setParticipant(response.data);
            }, err => {
                console.log(backendUtils.getErrorMessage(err));
            }).then(() => setShowSpinner(false))
                .catch((err) => console.log(err))
        }
    }

    useEffect(() => {
        getParticipant()
    }, [userId, context.backendUri])

    useEffect(() => {
        setUserId(context.userId)
    }, [context.userId])

    useEffect(() => {
        const id = participant?.stravaId === undefined ? "" : participant?.stravaId;
        const sex = participant?.sex === undefined ? "T" : participant?.sex;
        setStravaId(id)
        setSex(sex)
    }, [participant])

    const loadActiveEventsToJoin = () => {
        if (context.backendUri && participant) {
            setShowSpinner(true);
            backendUtils.getRequest(`${context.backendUri}/event/join/${userId}`, {},
                response => {
                    setActiveEvents(response.data);
                }, err => {
                    setError(backendUtils.getErrorMessage(err));
                }
            ).then(() => setShowSpinner(false))
                .catch((err) => setError(err))
        }
    }

    useEffect(() => {
        loadActiveEventsToJoin();
    }, [context.backendUri, userId, participant])

    const isSexValid = (sex) => {
        return sex === "M" || sex === "F"
    }

    const isStravaIdInvalid = () => {
        return stravaId && !stravaRegex.test(stravaId);
    }

    const isStravaIdValid = (stravaId) => {
        return stravaRegex.test(stravaId);
    }

    const prepareData = () => {
        return {
            "stravaId": stravaId, "sex": sex === "T" ? "" : sex
        };
    }

    const handleSubmitClicked = () => {
        if (valid) {
            if (!participant) {
                backendUtils.postRequest(`${context.backendUri}/participant/${userId}`, {}, prepareData(), () => {
                    toast("Data submitted")
                }, err => {
                    setError(getErrorMessage(err))
                }).then(() => {
                    getParticipant();
                }).catch((err) => setError(err))
            }
            if (participant) {
                backendUtils.patchRequest(`${context.backendUri}/participant/${userId}`, {}, prepareData(), () => {
                    toast("Data submitted")
                }, err => {
                    setError(getErrorMessage(err))
                }).then(() => {
                    getParticipant();
                }).catch((err) => setError(err))
            }
        }
    }

    const handleEventJoined = (event) => {
        toast(`Event ${event.name} joined`)
        loadActiveEventsToJoin();
    }

    return (<Container>
        <Row>
            <h2 className="text-center">Participant profile</h2>
            <hr/>
            <Col className="participant-form">
                {!participant ?
                    <div>
                        <p>Hi, welcome to Bike2Work competition!</p>
                        <p>
                            You are not fully participant yet! Least you should do in order to join upcoming daily
                            commute
                            events is to accept the rules, and smash update button. That will enable Moto Calendar in
                            Home page, so you can upload your rides.
                        </p>
                    </div> : <div/>
                }
                {
                    stravaId === "" ?
                        <div>
                            <p>
                                If you also would like to have your rides uploaded automatically or participate in
                                events
                                where distance matters, you will need to provide your Strava athlete id and select your
                                category, which we greatly encourage you to do.
                                Once this is done you also have to authorize us to read your rides from your Strava
                                account
                                by clicking 'Connect with Strava' button in navigation panel.
                            </p>
                            <p>
                                Check out the bat chat page for more detailed instructions.
                            </p>
                        </div> : <p/>
                }
                <Spinner animation="border" variant="primary" hidden={!showSpinner}/>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Check type="switch" label="I have read and agree with the terms and conditions"
                                    checked={rulesAccepted} onChange={event => setRulesAccepted(event.target.checked)}
                                    isValid={rulesAccepted} isInvalid={!rulesAccepted}/>
                        <a href="https://batchat.motorolasolutions.com/home/ls/space/4859397606014976/bike-2-work-krakow-space/article/8414b621-ff81-4bb1-be05-81d768721f2f">Bike2Work
                            competition Regulations</a>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <InputGroup>
                            <InputGroup.Text>Strava athlete id</InputGroup.Text>
                            <Form.Control value={stravaId} onChange={e => setStravaId(e.target.value)}
                                          placeholder={"Strava athlete id"} isInvalid={isStravaIdInvalid()}
                                          isValid={isStravaIdValid(stravaId) && isSexValid(sex)} id={"inputStravaId"}
                                          disabled={isStravaIdValid(participant?.stravaId)}
                            />
                        </InputGroup>
                        <Form.Text className="text-muted">The number from link to your profile
                            ( e.g. for profile link [https://www.strava.com/athletes/28943355], strava id is 28943355 )
                        </Form.Text>
                        <InputGroup>
                            <InputGroup.Text>Select category</InputGroup.Text>
                            <Form.Select onChange={e => setSex(e.target.value)}
                                         isValid={isStravaIdValid(stravaId) && isSexValid(sex)} value={sex} id={"inputCategoryId"}
                                         disabled={isSexValid(participant?.sex)}
                            >
                                <option value="T">Select category</option>
                                <option value="F">Women</option>
                                <option value="M">Men</option>
                            </Form.Select>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group className="update-btn">
                        <Button onClick={handleSubmitClicked} variant="success"
                                disabled={!valid}>Update</Button>
                    </Form.Group>
                </Form>
            </Col></Row>
        <Row>
            <Col>
                <hr/>
                {activeEvents?.length > 0 ? <h2 className="text-center">Join an event!</h2> : <div/>}
                <hr/>
                {activeEvents?.map(e => {
                    return (
                        <Row key={e.id}>
                            <h4 className='text-center'>{e.name}</h4>
                            <div className="text-center" >{e.startDate}>>>{e.endDate}</div>
                            <JoinEvent event={e} participant={participant} email={userId}
                                       handleJoinEvent={() => handleEventJoined(e)}/>
                            <hr className="hr m-3"/>
                        </Row>
                    )
                })}
            </Col></Row>
    </Container>)
}

export default NewParticipant;